import styles from "./Switch.module.scss"

const Switch = ({toggle, onChange, size=1}) => {
    return <>
    <div style={{zoom: size}} className={`${styles['container']} ${!!toggle?styles['on']:""}`}  onClick={()=>onChange(!toggle)}>
        <div className={`${styles['switcher']} `}></div>
    </div>
    </>
}

export default Switch;